// extracted by mini-css-extract-plugin
export default {"icon":"styles-module__icon___zpppR","title":"styles-module__title___Yd5Q0","description":"styles-module__description___WWOh1"};